import apiClient from "./axios"

// ---------- Payment From ----------
export const getPettyCashPaymentFromList = async (params = {}) => {
  const { data } = await apiClient.get("/petty-cash/payment-froms", { params })
  return data
}

export const createPettyCashPaymentFrom = async payload => {
  const { data } = await apiClient.post("/petty-cash/payment-froms", payload)
  return data
}

export const updatePettyCashPaymentFrom = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/petty-cash/payment-froms/${id}`, payload)
  return data
}

export const deletePettyCashPaymentFrom = async id => {
  const { data } = await apiClient.delete(`/petty-cash/payment-froms/${id}`)
  return data
}

// ---------- Payment Mode ----------
export const getPettyCashPaymentModeList = async (params = {}) => {
  const { data } = await apiClient.get("/petty-cash/payment-modes", { params })
  return data
}

export const createPettyCashPaymentMode = async payload => {
  const { data } = await apiClient.post("/petty-cash/payment-modes", payload)
  return data
}

export const updatePettyCashPaymentMode = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/petty-cash/payment-modes/${id}`, payload)
  return data
}

export const deletePettyCashPaymentMode = async id => {
  const { data } = await apiClient.delete(`/petty-cash/payment-modes/${id}`)
  return data
}

// ---------- Payment Purpose (For) ----------
export const getPettyCashPaymentPurposeList = async (params = {}) => {
  const { data } = await apiClient.get("/petty-cash/payment-fors", { params })
  return data
}

export const createPettyCashPaymentPurpose = async payload => {
  const { data } = await apiClient.post("/petty-cash/payment-fors", payload)
  return data
}

export const updatePettyCashPaymentPurpose = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/petty-cash/payment-fors/${id}`, payload)
  return data
}

export const deletePettyCashPaymentPurpose = async id => {
  const { data } = await apiClient.delete(`/petty-cash/payment-fors/${id}`)
  return data
}

// ---------- Reports ----------
export const getPettyCashBalance = async () => {
  const { data } = await apiClient.get("/petty-cash/reports/balance")
  return data
}

export const getPettyCashSummary = async (params = {}) => {
  const { data } = await apiClient.get("/petty-cash/reports/summary", { params })
  return data
}

export const getPettyCashDailySummary = async (params = {}) => {
  const { data } = await apiClient.get("/petty-cash/reports/daily", { params })
  return data
}

export const getPettyCashMonthlySummary = async (params = {}) => {
  const { data } = await apiClient.get("/petty-cash/reports/monthly", { params })
  return data
}
